import React from 'react';
import MarkersLayer from "./markers-layer.jsx";

const ItemsByLayersComponent = ({markers, layers, boName, geometryLib}) => {
    const markerLayer = [];

    [...layers].forEach(([, layer]) => {
        const markersCount = [];

        [...markers].forEach(([,marker]) => {
            if (geometryLib.poly.containsLocation(new google.maps.LatLng((marker.position.lat() + '').substring(0, 11), (marker.position.lng() + '').substring(0, 11)), layer)) {
                if (marker.type === "sentry-occurrence") {
                    marker.description.occ_reasons.forEach((occReason) => {
                        if (markersCount[occReason.name] !== undefined) {
                            markersCount[occReason.name].amount = markersCount[occReason.name].amount + 1;
                        } else {
                            markersCount[occReason.name] = {amount: 1, type: 'sentry-occurrence'};
                        }
                    });
                } else {
                    let names = [];
                    let type;

                    switch (marker.type) {
                        case "dispatch-attendance":
                            names.push(marker.title);
                            type = "dispatch-attendance";
                            break;
                        case "dispatch-bogcm":
                            names = marker.description.naturesArr;
                            type = "dispatch-dispatches";
                            break;
                        case "dispatch-dispatches":
                            names.push(marker.title);
                            type = "dispatch-bogcm";
                            break;
                    }

                    if (names.length > 0) {
                        for (let i = 0; i < names.length; i++) {
                            if (markersCount[names[i]] !== undefined) {
                                markersCount[names[i]].amount = markersCount[names[i]].amount + 1;
                            } else {
                                markersCount[names[i]] = {amount: 1, type: type};
                            }
                        }
                    }
                }

                markerLayer[layer.area.name] = markersCount;
            }
        });
    });

    const keys = Object.keys(markerLayer);

    return (
        <div>
                {
                    keys.map(key => {
                        const reasonsKey = Object.keys(markerLayer[key]);

                        let occI = 0;
                        let attendanceI = 0;
                        let dispatchI = 0;
                        let bosI = 0;

                        return (
                            <table className="w-full" key={Math.random().toString()}>
                                <tbody>
                                <tr>
                                    <td className="w-53.25 text-[12px]!">
                                        <div className={"pt-2.5 text-[15px]"}>
                                            <strong>{key}</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <table className={"w-[90%]"}>
                                            <tbody>
                                            {reasonsKey.map(function (reasonKey) {
                                                if (markerLayer[key][reasonKey].type === "sentry-occurrence") {
                                                    occI++;
                                                    return (<MarkersLayer
                                                        key={Math.random().toString()} index={occI}
                                                        markerKey={key} reasonKey={reasonKey}
                                                        markerLayer={markerLayer}/>);
                                                }
                                            })}

                                            {reasonsKey.map(function (reasonKey) {
                                                if (markerLayer[key][reasonKey].type === "dispatch-attendance") {
                                                    attendanceI++;
                                                    return (<MarkersLayer
                                                        key={Math.random().toString()} index={attendanceI}
                                                        markerKey={key} reasonKey={reasonKey}
                                                        markerLayer={markerLayer}/>);
                                                }
                                            })}

                                            {reasonsKey.map(function (reasonKey) {
                                                if (markerLayer[key][reasonKey].type === "dispatch-bogcm") {
                                                    dispatchI++;
                                                    return (<MarkersLayer
                                                        key={Math.random().toString()} index={dispatchI}
                                                        markerKey={key} reasonKey={reasonKey} boName={boName}
                                                        markerLayer={markerLayer}/>);
                                                }
                                            })}

                                            {reasonsKey.map(function (reasonKey) {
                                                if (markerLayer[key][reasonKey].type === "dispatch-dispatches") {
                                                    bosI++;
                                                    return (<MarkersLayer
                                                        key={Math.random().toString()} index={bosI}
                                                        markerKey={key} reasonKey={reasonKey}
                                                        markerLayer={markerLayer}/>);
                                                }
                                            })}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        );
                    })
                }
        </div>
    );
};

export default ItemsByLayersComponent;